import { Component } from '@angular/core';
import { EstoqueRequest } from 'src/app/core/models/estoque-request';
import { Produto } from 'src/app/core/models/produto';
import { EstoqueService } from 'src/app/core/services/estoque.service';
import { ProdutoService } from 'src/app/core/services/produto.service';
import { MessageService } from 'primeng/api';



@Component({
  selector: 'app-estoque',
  templateUrl: './estoque.component.html'
})
export class EstoqueComponent {

  produto: Produto | null = null;
  produtos: Produto[] = [];
  quantidade: number = 0;

  constructor(
    private produtoService: ProdutoService,
    private estoqueService: EstoqueService,
    private messageService: MessageService
  ) {}

  ngOnInit(){
  
    this.produtoService.selecionar().subscribe((produtos: Produto[]) => {
      this.produtos = produtos;
    });
  }

  adicionar(quantidade: number) {
    if (this.produto) {
      const estoqueRequest = new EstoqueRequest();
      estoqueRequest.produtoId = this.produto.id;
      estoqueRequest.quantidade = quantidade;
  
      this.estoqueService.adicionar(estoqueRequest).subscribe(
        response => {
          console.log('Produto adicionado com sucesso:', response);
          this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Estoque atualizado com sucesso!' });
          this.quantidade = 0;
          this.produto = null;

        },
        error => {
          console.error('Erro ao adicionar o produto:', error);
          // Tenta capturar a mensagem de erro em diferentes formatos
          const msg = error?.error?.message || error?.message || error?.error || 'Erro ao adicionar o produto.';
          this.messageService.add({ severity: 'error', summary: 'Erro', detail: msg });
        }
      );
    } else {
      console.error('Nenhum produto selecionado.');
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Nenhum produto selecionado.' });
    }
  }

  remover(quantidade: number) {
    if (this.produto) {
      const estoqueRequest = new EstoqueRequest();
      estoqueRequest.produtoId = this.produto.id;
      estoqueRequest.quantidade = quantidade;
  
      this.estoqueService.remover(estoqueRequest).subscribe(
        response => {
          console.log('Produto removido com sucesso:', response);
          this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Estoque atualizado com sucesso!' });
          this.quantidade = 0;
          this.produto = null;
        },
        error => {
          console.error('Erro ao remover o produto:', error);
          // Tenta capturar a mensagem de erro em diferentes formatos
          const msg = error?.error?.message || error?.message || error?.error || 'Erro ao remover o produto.';
          this.messageService.add({ severity: 'error', summary: 'Erro', detail: msg });
        }
      );
    } else {
      console.error('Nenhum produto selecionado.');
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Nenhum produto selecionado.' });
    }
  }
}
